// extracted by mini-css-extract-plugin
export default {"loader_container":"Loading_loader_container__Jzar1","loader":"Loading_loader__K21P0"};